export default __webpack_public_path__ + "static/sr_wo-2c24dd5c49caded693528c0091a8aa66.png";